import RenderIf from "common/components/RenderIf";
import Skeleton from "common/components/ui/Skeleton";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

import { formatBillingDate } from "../../../../utils";
import SubscriptionPaymentMethod from "./SubscriptionPaymentMethod";

import type { ReactNode } from "react";

interface SubscriptionInfoProps {
  subscription:
    | Subscription
    | RentedSubscription
    | AgencySubscription
    | undefined;
  nextBillingAt: number | undefined;
  isLoading: boolean;
  buttonComponent: ReactNode;
}

export default function SubscriptionInfo({
  nextBillingAt,
  isLoading,
  subscription,
  buttonComponent,
}: SubscriptionInfoProps) {
  const isSubscriptionNonRenewing = subscription?.status === "non_renewing";

  let billingDate: string;
  if (nextBillingAt) {
    billingDate = formatBillingDate(nextBillingAt * 1000);
  } else if (isSubscriptionNonRenewing) {
    billingDate = formatBillingDate(subscription.cancelled_at * 1000);
  }

  return (
    <div className="flex flex-col lg:flex-row items-center gap-x-2 [&>button]:ml-auto max-lg:[&>button]:mt-9">
      <div className="flex w-full flex-col-reverse gap-3 lg:gap-2 lg:flex-row lg:items-center">
        {isLoading ? (
          <Skeleton className="h-5 w-48" />
        ) : (
          <RenderIf condition={!!billingDate}>
            <p className="text-sm-medium text-black-500">
              {isSubscriptionNonRenewing ? "Ends" : "Next billing"} on{" "}
              {billingDate}
            </p>
          </RenderIf>
        )}

        {!!subscription && (!!billingDate || isLoading) && (
          <span className="inline-flex max-lg:w-full lg:h-3 lg:border-r max-lg:border-t-2 border-black-200 max-lg:border-dotted" />
        )}

        {/* Payment method - only visible if subscription exists */}
        {!!subscription && (
          <SubscriptionPaymentMethod
            subscriptionId={subscription.id}
            isCustomerSubscription={subscription.type === "agency"}
          />
        )}
      </div>

      {buttonComponent}
    </div>
  );
}
